import script from "./WithdrawIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawIndex.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawIndex.vue?vue&type=style&index=0&id=5199dc01&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5199dc01"]])

export default __exports__